import {
  MyAccountTheme,
  MyInsuranceFormAddButtonClasses,
} from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const addButtonStyles = makeStyles<
  MyAccountTheme,
  object,
  MyInsuranceFormAddButtonClasses
>(
  ({ palette }) => ({
    button: {
      padding: 0,
      margin: '0 0 5px 0',
      justifyContent: 'flex-start',
      backgroundColor: palette.common.white,
      '&:hover': {
        backgroundColor: palette.common.white,
      },
    },
    caption: {
      margin: '0 5px',
      lineHeight: 1.75,
    },
  }),
  { name: 'Insurance_Form_Add_Button' }
)

export default addButtonStyles
